import React, { useState } from "react";
import { UserPlus, X, ArrowRight } from "lucide-react";
import { PersonBadge } from "@/components/PersonBadge";
import { computeInitialsMap } from "@/lib/format";

export default function PeopleSection({ participants, onAdd, onRemove, onContinue }) {
  const [name, setName] = useState("");
  const imap = computeInitialsMap(participants);

  const submit = (e) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    onAdd(n);
    setName("");
  };

  return (
    <div data-testid="people-section" className="gz-rise">
      <div className="mb-1 flex items-baseline justify-between">
        <h2 className="text-[15px] font-semibold tracking-tight">Who's splitting this bill?</h2>
        <span className="text-sm text-[var(--gz-muted)] shrink-0 ml-2">{participants.length}</span>
      </div>
      <p className="text-xs text-[var(--gz-muted)] mb-4">
        Add everyone first, as many people as you need. You'll mark who ordered what in a moment.
      </p>

      <form onSubmit={submit} className="flex gap-2 mb-5">
        <input
          data-testid="person-name-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          maxLength={24}
          className="flex-1 min-w-0 h-12 rounded-xl border border-[var(--gz-line)] bg-transparent px-4 outline-none focus:border-[var(--gz-primary)] transition-colors"
          aria-label="Participant name"
        />
        <button
          data-testid="add-person-btn"
          type="submit"
          aria-label="Add person"
          className="h-12 w-12 shrink-0 grid place-items-center rounded-xl bg-[var(--gz-primary)] text-white active:scale-95 transition-transform"
        >
          <UserPlus size={20} />
        </button>
      </form>

      {participants.length === 0 ? (
        <div className="text-center py-10 text-[var(--gz-muted)] text-sm border border-dashed border-[var(--gz-line)] rounded-xl">
          No one has been added yet. Type a name and press Enter.
        </div>
      ) : (
        <div className="space-y-2">
          {participants.map((p) => (
            <div
              key={p.id}
              data-testid={`person-row-${p.id}`}
              className="flex items-center gap-3 py-2.5 px-3 rounded-xl border border-[var(--gz-line)] gz-rise"
            >
              <PersonBadge person={p} size={38} label={imap[p.id]} />
              <span className="flex-1 min-w-0 font-medium truncate">{p.name}</span>
              <button
                data-testid={`remove-person-${p.id}`}
                onClick={() => onRemove(p.id)}
                aria-label={`Remove ${p.name}`}
                className="grid place-items-center h-10 w-10 shrink-0 rounded-full text-[var(--gz-muted)] hover:text-red-500 active:scale-90 transition-transform"
              >
                <X size={18} />
              </button>
            </div>
          ))}
        </div>
      )}

      {participants.length > 0 && (
        <button
          data-testid="continue-to-receipt-btn"
          onClick={onContinue}
          className="mt-5 w-full py-3.5 rounded-full bg-[var(--gz-primary)] text-white font-semibold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
        >
          Continue to assigning <ArrowRight size={18} />
        </button>
      )}
    </div>
  );
}
